<template>
  <div class="">
    <div class="section-title" style="text-align: center; margin: 40px 0;">
      Płatność
    </div>

    <v-container
      v-if="packageData && packageData.active"
      class="container mt-10"
      fluid
    >
      <v-row justify="center" align="baseline">
        <v-col cols="12" sm="10" md="8" lg="6" xl="5">
          <PaymentForm
            :profile="profile"
            :submitAction="'payment/createTheoryPracticeWorkshopOrder'"
            :submitParams="{ theoryPracticeWorkshopId: $route.params.id }"
          />
        </v-col>
      </v-row>
    </v-container>

    <v-container
      v-else-if="packageData && !packageData.active"
      class="container mt-10"
      fluid
    >
      <v-row justify="center" align="baseline">
        <v-col cols="12" sm="6" md="4" lg="4" xl="3">
          <v-card shaped elevation="5" class="card">
            <v-container>
              <p style="color:#8B857D; margin-bottom: 40px;">
                Zajęcia obecnie są nieaktywne. Spróbuj ponownie bliżej ich
                rozpoczęcia.
              </p>

              <a
                href="https://dagajoga.pl/index.php/zajecia-na-zywo/"
                class="primary-button"
                >OK</a
              >
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-container v-else class="container mt-10" fluid>
      <v-row justify="center" align="baseline">
        <v-col cols="12" sm="6" md="4" lg="4" xl="3">
          <v-card shaped elevation="5" class="card">
            <v-container class="mb-12">
              <h3 class="text-center" style="padding: 1rem">
                Przepraszamy, te warsztaty nie są już dostępne
              </h3>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import PaymentForm from "../../components/forms/PaymentForm.vue";

export default {
  metaInfo: {
    title: "Dagajoga kurs online - portal jogi online",
    meta: [
      { charset: "utf-8" },
      {
        name: "description",
        content:
          "Dagajoga to szkoła internetowa o wszechstronnym systemie budowania praktyki własnej. Praktyka jogi połączona z nowoczesnymi metodami ćwiczeń funkcjonalnych, ćwiczeń wzmacniających.",
      },
    ],
  },
  name: "TheoryPracticeWorkshopPayment",
  components: {
    PaymentForm,
  },
  computed: {
    packageData: function() {
      return this.$store.getters[
        "theoryPracticeWorkshops/getTheoryPracticeWorkshop"
      ];
    },
    profile() {
      return this.$store.getters["auth/getProfile"];
    },
  },
  created() {
    this.$store.commit("payment/SET_INIT_VALUES");
    this.$store.dispatch(
      "theoryPracticeWorkshops/fetchTheoryPracticeWorkshop",
      this.$route.params.id
    );
  },
  async mounted() {
    await this.$store.dispatch("auth/fetchUserProfile");
    const token = window.localStorage.getItem("userToken");
    if (!token) {
      this.$store.dispatch(
        "snackbar/setSnackbar",
        {
          color: "red",
          icon: "exclamation-triangle",
          message:
            "Zakup warsztatów teoria i praktyka dostępny jest wyłącznie dla zalogowanych użytkowników",
        },
        { root: true }
      );
      this.$store.dispatch("snackbar/toggleSnackbar", true, { root: true });
      this.$router.push({
        name: "Auth",
        params: {
          previousPath: `/warsztaty-teoria-i-praktyka/platnosc/${this.$route.params.id}`,
        },
      });
    }
  },
  destroyed() {
    this.$store.commit("payment/SET_INIT_VALUES");
  },
};
</script>


<style scoped>
.card {
  background: #d9d9d9;
  border-radius: 20px !important;
  box-shadow: 0px 0px 100px 25px #b6afa5 !important;
  color: #8b857d;
}
.card {
  background-color: #d9d9d9;
  color: #54514c;
  border-radius: 32px !important;
  position: relative;
  width: 100%;
  box-shadow: 0px 0px 100px 25px #b6afa5;
}
</style>
